import request from '@/utils/request'
import URL from '@/api/urlTranslator'

// gp说明记录 查询全部
export function queryGpExplainRecord(params) {
  return request({
    url: URL.booking.gpExplainRecord.queryGpExplainRecord,
    method: 'GET',
    params
  })
}

// gp说明记录 批量新增
export function batchAddGpExplainRecord(data) {
  return request({
    url: URL.booking.gpExplainRecord.batchAdd,
    method: 'POST',
    data: data
  })
}

